module.exports = __webpack_public_path__ + "img/gentlemen-club-carousel-1.3cac545c.png";